/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types'
import {mergeClasses as buildClass} from "../../../utils";
import {TextColors} from "../../../config/styles";
import {withSpacing} from "../../hoc/styles/withSpacing";
import {compose} from "redux";
import {withTextColor} from "../../hoc/styles/withTextColor";

const style = {
    sidebar: 'finder-title__sidebar',
    finderTitle: 'h2',
    groupTitle: 'p-group-title'
};

class _Title extends React.Component {

    static propTypes = {
        color: PropTypes.oneOf(Object.values(TextColors)),
        text: PropTypes.string,
        type: PropTypes.string
    };

    render() {
        const { color, style, type, text, bold, className, onClick, heading } = this.props;

        const classes = [
            "react__title",
            style || type,
            color,
            bold && "bold",
            className
        ];

        const Tag = heading ? heading : "div";

        return (<Tag className={buildClass(classes)} onClick={onClick}>{text}</Tag>)
    }

}

export const Title = compose(withTextColor, withSpacing)(_Title);

Title.style = style;
